/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import ModalLayerCustomApi from "./ModalLayerCustomApi";
import ApiTable from "./ApiTable";

/*REDUX*/
import {
  create_layer_custom_api,
  request_direct_to_user_api,
} from "../../App/actions/openApiActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import ICON_SUCCESS from "../../Assets/jsx/ICON_SUCCESS";

/*FUNCTION*/
import uuid from "../../App/validation/uuid";
import { getGeoLayer } from "../../App/reduxHelper/layer";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const http_methods = [
  {
    key: "post",
    name: "POST",
    color: "#c8a000",
  },
  {
    key: "get",
    name: "GET",
    color: "#297e21",
  },
];

const geometry_types = [
  {
    key: "point",
    name: "Point",
  },
  {
    key: "polygon",
    name: "Polygon",
  },
  {
    key: "linstring",
    name: "LineString",
  },
];

const createRow = () => {
  return { id: uuid(), key: "", value: "" };
};

const createRows = (rows_object) => {
  const result = [];
  for (const key in rows_object) {
    result.push({
      id: uuid(),
      key: key,
      value: rows_object[key],
    });
  }
  return result;
};

const convert_to_url = (param, index) => {
  if (index === 0) {
    return `${param?.key ? `?${param?.key}` : ""}${
      param?.value ? `=${param?.value}` : ""
    }`;
  } else {
    return `${param?.key ? `&${param?.key}` : ""}${
      param?.value ? `=${param?.value}` : ""
    }`;
  }
};

const convert_to_api_attributes = (data) => {
  let result = {};
  data.forEach((item) => {
    result[item?.key] = item?.value;
  });
  return result;
};

const get_http_color = (method) => {
  const color =
    http_methods.find((item) => item.key === method)?.color || "#000000";
  return color;
};

const ApiInput = ({
  layer,
  project,
  auth,
  from,
  toggle_modal_api_input,
  create_layer_custom_api,
  request_direct_to_user_api,
  post_activities,
}) => {
  const [layer_name, set_layer_name] = useState("");
  const [description, set_description] = useState("");
  const [folder, set_folder] = useState("");
  const [modal_layer_name, set_modal_layer_name] = useState(false);
  const [geometry_type, set_geometry_type] = useState("Point");
  const [page, set_page] = useState("Test");
  const [response, set_response] = useState({});
  // const [latitude_path, set_latitude_path] = useState([]);
  // const [longitude_path, set_longitude_path] = useState([]);
  // const [properties_path, set_properties_path] = useState([]);
  // const [features_path, set_features_path] = useState([]);
  // const [total_data_path, set_total_data_path] = useState([]);
  // const [is_total_data_valid, set_is_total_data_valid] = useState(false);
  const [is_feature_valid, set_is_feature_valid] = useState(false);
  const [read_open_api, set_read_open_api] = useState({
    api_endpoint: "",
    http_method: "get",
    headers: [],
    params: [],
    body: [],
  });

  useEffect(() => {
    // const from = this.props.from
    // if (from === "editor") {
    const geo_layer = getGeoLayer(layer);

    const headers = createRows(geo_layer?.headers) || [];
    const params = createRows(geo_layer?.params) || [];
    const body = createRows(geo_layer?.body) || [];

    set_geometry_type(geo_layer?.geometry_type || "Point");
    set_response({});
    // set_latitude_path(geo_layer?.latitude_path || []);
    // set_longitude_path(geo_layer?.longitude_path || []);
    // set_properties_path(geo_layer?.properties_path || []);
    // set_features_path(geo_layer?.features_path || []);
    set_read_open_api({
      api_endpoint: geo_layer?.api_endpoint || "",
      http_method: geo_layer?.http_method || "get",
      headers: [...headers, createRow("Headers")],
      params: [...params, createRow("Params")],
      body: [...body, createRow("Body")],
    });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // const { geometry_type, response } = this.state

    const response_data = response?.data || {};
    if (
      response_data?.type === "FeatureCollection" &&
      Array.isArray(response_data?.features)
    ) {
      // const validity = this.check_validity(response?.features);

      set_is_feature_valid(true);
      // validity?.is_feature_valid

      const first_feature_data_type =
        response_data?.features?.[0]?.geometry?.type;
      if (first_feature_data_type) {
        set_geometry_type(first_feature_data_type);
      }
    }

    // const feature_path_old = prevState?.features_path;
    // const feature_path_new = this.state?.features_path;
    // if (JSON.stringify(feature_path_old) !== JSON.stringify(feature_path_new)) {
    //   const selected_features_obj = get_nested_object(response?.data || {}, feature_path_new) || {};
    //   const validity = this.check_validity(selected_features_obj, geometry_type);
    //   this.setState({
    //     is_feature_valid: validity?.is_feature_valid
    //   })
    // }

    // const total_data_path_old = prevState?.total_data_path;
    // const total_data_path_new = this.state?.total_data_path;
    // if (JSON.stringify(total_data_path_old) !== JSON.stringify(total_data_path_new)) {
    //   const selected_total_data_obj = get_nested_object(response?.data || {}, total_data_path_new) || {};
    //   if (!isNaN(selected_total_data_obj)) {
    //     this.setState({
    //       is_total_data_valid: true
    //     })
    //   } else {
    //     this.setState({
    //       is_total_data_valid: false
    //     })
    //   }
    // }
  }, [response]);

  const handle_next = () => {
    set_modal_layer_name(!modal_layer_name);
  };

  const handle_save = async () => {
    const { geo_project } = project;
    const { headers, params, body } = read_open_api;

    const body_request = {
      name: layer_name,
      description,
      type: geometry_type,
      folder,
      user_id: auth.user._id,
      geo_project_id: geo_project._id,
      is_custom_endpoint: true,
      read_open_api: {
        ...read_open_api,
        headers: headers.slice(0, headers?.length - 1),
        params: params.slice(0, params?.length - 1),
        body: body.slice(0, body?.length - 1),
      },
      status: "original",
      architecture: "api",
      is_show_and_fly: true,
      properties: [
        {
          key: "fill_color",
          name: "color",
          type: "color",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: "#1E5E96",
        },
        {
          key: "opacity",
          name: "opacity",
          type: "range",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: 0.5,
          min: 0,
          max: 1,
          step: 0.1,
        },
        {
          key: "outline_color",
          name: "outline_color",
          type: "color",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: "#1E5E96",
        },
        {
          key: "outline_width",
          name: "outline_width",
          type: "number",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: 1,
        },
        {
          key: "text_field",
          name: "label",
          type: "text",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: "point",
        },
        {
          key: "is_using_label",
          name: "Use label",
          type: "checkbox",
          array_templates: [],
          isHighlight: false,
          isHide: true,
          isStyle: true,
          defaultValue: false,
        },
      ],
    };

    await create_layer_custom_api(body_request);

    await post_activities({
      action: "connect_to_api",
    });

    if (toggle_modal_api_input) {
      toggle_modal_api_input();
    }
  };

  const params_merge = () => {
    const { params } = read_open_api;
    const result = params
      .slice(0, params?.length - 1)
      .map((param, index) => convert_to_url(param, index));
    return result.join("");
  };

  const send_request = async () => {
    const { http_method, api_endpoint, headers, body } = read_open_api;

    if (api_endpoint) {
      const fetched_response = await request_direct_to_user_api({
        http_method,
        api_endpoint,
        geometry_type,
        headers: convert_to_api_attributes(
          headers.slice(0, headers?.length - 1),
        ),
        params: params_merge(),
        body: convert_to_api_attributes(body.slice(0, body?.length - 1)),
      });

      set_response(fetched_response);
    }
  };

  const handle_change = (e) => {
    const { name, value } = e?.target;
    switch (name) {
      case "layer_name":
        set_layer_name(value);
        break;
      case "description":
        set_description(value);
        break;
      case "folder":
        set_folder(value);
        break;
      case "geometry_type":
        set_geometry_type(value);
        break;
      default:
        break;
    }
  };

  const handle_change_read_open_api = (e) => {
    const { name, value } = e?.target;
    set_read_open_api((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const delete_row = (id, type) => {
    const type_lower = type?.toLowerCase();
    set_read_open_api((prev) => ({
      ...prev,
      [type_lower]: prev[type_lower]?.filter((header) => header?.id !== id),
    }));
  };

  const edit_cell = (type, row) => {
    const lowerCasetype = type?.toLowerCase();
    set_read_open_api((prev) => {
      let array_of_object = structuredClone(prev[lowerCasetype]);
      const index = array_of_object.findIndex((item) => item?.id === row?.id);
      if (index >= 0) {
        array_of_object[index] = row;

        const last_object = array_of_object.at(-1);
        if (last_object?.key !== "" || last_object?.value !== "") {
          array_of_object.push(createRow());
        }
      }
      return {
        ...prev,
        [lowerCasetype]: array_of_object,
      };
    });
  };

  //local storage
  const language = localStorage?.language ? localStorage?.language : "ina";

  const { http_method, headers, params, body, api_endpoint } = read_open_api;

  //global props
  const folders = project?.geo_project?.folders;

  //content
  return (
    <main>
      {!modal_layer_name ? (
        <>
          <section className="flex gap_40"></section>
          <section className="flex gap_5">
            <select
              name="http_method"
              style={{
                color: get_http_color(http_method),
              }}
              value={http_method}
              onChange={handle_change_read_open_api}
              className="w_100"
            >
              {http_methods.map((method) => (
                <option
                  style={{ color: method.color }}
                  key={method.key}
                  value={method.key}
                >
                  {method.name}
                </option>
              ))}
            </select>
            <input
              name="api_endpoint"
              type="text"
              value={api_endpoint}
              onChange={handle_change_read_open_api}
              placeholder={dict["Enter URL"][language]}
            />
            <div
              onClick={() => {
                send_request();
              }}
              className="center_perfect pointer bg_black text_white button_inactive rounded_5 font_18 w_100 h_40"
            >
              {`Send >`}
            </div>
          </section>

          <section className="flex justify_between marginTop_10 marginBottom_10 h_40">
            <div className="font_16 center_perfect gap_10 bg_white padding_x_10 rounded_5">
              <div
                className={`pointer noselect ${
                  page === "Headers" ? "underline bold" : ""
                }`}
                onClick={() => set_page("Headers")}
              >
                Headers
              </div>
              <div
                className={`pointer noselect ${
                  page === "Params" ? "underline bold" : ""
                }`}
                onClick={() => set_page("Params")}
              >
                Params
              </div>
              <div
                className={`pointer noselect ${
                  page === "Body" ? "underline bold" : ""
                }`}
                onClick={() => set_page("Body")}
              >
                Body
              </div>
              <div
                className={`pointer noselect ${
                  page === "Test" ? "underline bold" : ""
                }`}
                onClick={() => set_page("Test")}
              >
                Request Test
              </div>
            </div>

            <div className="flex align_end gap_10">
              <div className="flex justify_end align_center text_right h_50">
                <label className="text_right">
                  {dict["Geometry Type"][language]}
                </label>
              </div>
              <select
                name="geometry_type"
                value={geometry_type}
                onChange={handle_change}
                className="w_100"
              >
                {geometry_types.map((method) => (
                  <option key={method.key} value={method.name}>
                    {method.name}
                  </option>
                ))}
                {!geometry_types
                  .map((method) => method?.name)
                  .includes(geometry_type) && (
                  <option
                    key={geometry_type?.toLowerCase()}
                    value={geometry_type}
                  >
                    {geometry_type}
                  </option>
                )}
              </select>
            </div>
          </section>

          {page === "Headers" && (
            <section className="marginBottom_10">
              <ApiTable
                title="Headers"
                data={headers}
                edit_cell={edit_cell}
                delete_row={delete_row}
              />
            </section>
          )}
          {page === "Params" && (
            <section className="marginBottom_10">
              <ApiTable
                title="Params"
                full_url={`${api_endpoint}${params_merge()}`}
                data={params}
                edit_cell={edit_cell}
                delete_row={delete_row}
              />
            </section>
          )}
          {page === "Body" && (
            <section className="marginBottom_10">
              <ApiTable
                title="Body"
                data={body}
                edit_cell={edit_cell}
                delete_row={delete_row}
              />
            </section>
          )}

          {page === "Test" && (
            <>
              <section className="marginTop_20 marginBottom_10">
                <div className="flex justify_between">
                  <label>Response</label>
                  <label>Status: {response.status}</label>
                </div>
                <textarea
                  value={JSON.stringify(response.data, null, 2)}
                  onChange={() => {}}
                  className="padding_10 pre h_300 border_grey rounded_5 scroll_y_auto bg_white monospace"
                />
              </section>

              {/* {response?.status === 200 &&
                <section className="bg_white marginBottom_10 min_h_75 max_h_200 scroll_y_auto border_grey padding_5 rounded_5">
                  <div className="">

                  </div>
                </section>} */}

              {/* <section className="flex gap_10 w_full">
                <div className="w_80_percent">
                  {response?.status === 200 && (
                    <Path
                      handle_delete_path={this.handle_delete_path}
                      handle_add_path={this.handle_add_path}
                      path={features_path}
                      object={response.data}
                      title="Array of geojson features"
                    />
                  )}
                </div>
              </section> */}

              {/* {response?.status === 200 &&
                <section className="bg_white marginBottom_10 min_h_75 max_h_200 scroll_y_auto border_grey padding_5 rounded_5">
                  <div className="">
                    <label className="bold">Total data (for pagination)</label>
                    <div className="flex">
                      <label className="w_20 center_perfect">{">"}</label>
                      <Path
                        handle_delete_path={this.handle_delete_path}
                        handle_add_path={this.handle_add_path}
                        variable_name="total_data_path"
                        path={total_data_path}
                        object={response.data}
                        title="Path"
                        is_valid={is_total_data_valid}
                      />
                    </div>
                    <hr className="margin_y_2" />
                    <label className="bold">Array of geojson features</label>
                    <div className="flex">
                      <label className="w_20 center_perfect">{">"}</label>
                      <Path
                        handle_delete_path={this.handle_delete_path}
                        handle_add_path={this.handle_add_path}
                        variable_name="features_path"
                        path={features_path}
                        object={response.data}
                        title="Path"
                        is_valid={is_feature_valid}
                      />
                    </div>
                  </div>
                </section>} */}

              {/* {
                Array.isArray(selected_features_path) &&
                (
                  <section className="bg_white marginBottom_10 min_h_75 max_h_200 scroll_y_auto border_grey padding_5 rounded_5">
                    <div className="">
                      <div className="flex">
                        <label className="w_20 center_perfect">{">"}</label>
                        <Path
                          handle_delete_path={this.handle_delete_path}
                          handle_add_path={this.handle_add_path}
                          path={properties_path}
                          object={selected_features_path?.[0] || {}}
                          title="Properties"
                        />
                      </div>
                      <hr className="margin_y_2" />
                      <div className="flex">
                        <label className="w_20 center_perfect">{">"}</label>
                        <Path
                          handle_delete_path={this.handle_delete_path}
                          handle_add_path={this.handle_add_path}
                          path={latitude_path}
                          object={selected_features_path?.[0] || {}}
                          title="Latitude"
                        />
                      </div>
                      <hr className="margin_y_2" />
                      <div className="flex">
                        <label className="w_20 center_perfect">{">"}</label>
                        <Path
                          handle_delete_path={this.handle_delete_path}
                          handle_add_path={this.handle_add_path}
                          path={longitude_path}
                          object={selected_features_path?.[0] || {}}
                          title="Longitude"
                        />
                      </div>
                    </div>
                  </section>
                )} */}
            </>
          )}
          {response?.status === 200 && from !== "editor" && (
            <div className="flex justify_end marginTop_10 gap_10">
              {is_feature_valid && (
                <div className="flex justify_end">
                  <ICON_SUCCESS alt={"read as geojson"} />
                </div>
              )}
              <div
                onClick={() => handle_next()}
                className="pointer bg_blue text_white button_inactive padding_5 rounded_5 font_18"
              >
                Next
              </div>
            </div>
          )}
        </>
      ) : (
        <ModalLayerCustomApi
          handle_change={handle_change}
          folder={folder}
          folders={folders}
          layer_name={layer_name}
          description={description}
          handle_back={handle_next}
          handle_save={handle_save}
        />
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  // request_by_client_api,
  request_direct_to_user_api,
  create_layer_custom_api,
  post_activities,
})(ApiInput);
